module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col page"
  }, [_c('div', {
    staticClass: "flex-col group_3"
  }, [_c('div', {
    staticClass: "flex-col group_4"
  }, [_c('div', {
    staticClass: "flex-col section_1"
  }, [_c('div', {
    staticClass: "justify-between group_5"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('img', {
    staticClass: "image_4",
    attrs: {
      "src": this.mixin_imgs[this.getOSSImg(_vm.carDetail.carImg)]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_7"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_vm._v(_vm._s(_vm.carDetail.carTypeName))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row group_8"
  }, [_c('span', {
    staticClass: "text_4"
  }, [_vm._v(_vm._s(_vm.carDetail.carTypeLevel))]), _vm._v(" "), (_vm.carDetail.carTypePower) ? _c('div', {
    staticClass: "section_2"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text_5"
  }, [_vm._v(_vm._s(_vm.carDetail.carTypePower))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row group_9"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("定金")]), _vm._v(" "), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
    staticClass: "text_8"
  }, [_vm._v(_vm._s(_vm.carDetail.depositPrice))])])])]), _vm._v(" "), _c('span', {
    staticClass: "text_9"
  }, [_vm._v(_vm._s(_vm.carDetail.orderStateDesc))])]), _vm._v(" "), _c('div', {
    staticClass: "justify-between group_10"
  }, [_c('span', {
    staticClass: "text_10"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "text_11"
  }, [_vm._v(_vm._s(_vm.carDetail.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "justify-between group_11"
  }, [_c('span', {
    staticClass: "text_12"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('span', {
    staticClass: "text_13"
  }, [_vm._v(_vm._s(_vm.carDetail.phone))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-col section_3"
  }, [_c('div', {
    staticClass: "justify-between"
  }, [_c('span', {
    staticClass: "text_14"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('span', {
    staticClass: "text_15"
  }, [_vm._v(_vm._s(_vm.carDetail.orderId))]), _vm._v(" "), _c('div', {
    staticClass: "section_4"
  }), _vm._v(" "), _c('span', {
    staticClass: "text_16",
    on: {
      "click": function($event) {
        return _vm.copy(_vm.carDetail.orderId)
      }
    }
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-between group_14"
  }, [_c('span', {
    staticClass: "text_17"
  }, [_vm._v("付款时间")]), _vm._v(" "), _c('span', {
    staticClass: "text_18"
  }, [_vm._v(_vm._s(_vm.carDetail.lastPayTime))])]), _vm._v(" "), _c('div', {
    staticClass: "justify-between group_15"
  }, [_c('span', {
    staticClass: "text_19"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('span', {
    staticClass: "text_20"
  }, [_vm._v(_vm._s(_vm.carDetail.payType == 2 ? "支付宝" : "微信"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row section_5"
  }, [_c('a', {
    staticClass: "flex-col items-center text-wrapper_1 btn",
    attrs: {
      "href": ("tel:" + (_vm.carDetail.commissionerPhone))
    }
  }, [_vm._v("联系专员")]), _vm._v(" "), (_vm.carDetail.orderState == 3) ? _c('div', {
    staticClass: "flex-col items-center text-wrapper_2 btn",
    on: {
      "click": _vm.goGetCoupon
    }
  }, [_vm._v("我的权益")]) : _vm._e(), _vm._v(" "), (_vm.carDetail.orderState == 2) ? _c('div', {
    staticClass: "flex-col items-center text-wrapper_2 btn payBtn",
    on: {
      "click": _vm.goPay
    }
  }, [_vm._v("\n                立即支付\n            ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0731010e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0731010e","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/order/orderDetail.vue
// module id = 275
// module chunks = 320 321